import { gql } from '@apollo/client';

/**
 * Query to fetch Cloud Foundry applications for a specific application
 *
 * @param applicationId - The ID of the application
 * @returns Paginated list of Cloud Foundry applications with total count
 */
export const GET_CLOUD_FOUNDRY_APPLICATIONS = gql`
  query GetCloudFoundryApplications($applicationId: Int!) {
    resources {
      application(applicationId: $applicationId) {
        resources {
          cloudFoundryApplicationsPaged {
            totalCount
            cloudFoundryApplications {
              orgName
              datacenter
              cfAppName
              status
              site
            }
          }
        }
      }
    }
  }
`;
